import React,{useEffect, useState} from 'react';
import {IconButton,Typography,Grid,useTheme, Button,Dialog,DialogActions as MuiDialogActions ,DialogContent as MuiDialogContent ,DialogContentText,DialogTitle as MuiDialogTitle } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import { MuiThemeProvider,withStyles } from "@material-ui/core/styles";
import { pathOr, clone } from 'ramda';
import { validateForm } from '../../../../common/utils';
import { Scrollbars } from 'react-custom-scrollbars';
import CloseIcon from '@material-ui/icons/Close';
import List from "./List";
import Inbound from "./Inbound";
import { toast } from 'react-toastify';
import CircularProgress from '@material-ui/core/CircularProgress';

import { submitInOutboundEmail} from "../../../../store/actions/edit.actions";


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);
export default function EmailSettings(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const currentTheme = useTheme();
  const [validForm, setValidForm]=useState(false);
  const [errors, setErrors] = useState({});

  const [editValues, setEditValues]=useState({});
  const [loading, setLoading]=useState(false);
  const [outboundList, setOutboundList] = useState([]);
  const [fields, setFields] = useState({});
  const { userPreference, config } = useSelector((state) => state.config);
  const calendar_format = pathOr(config.default_date_format, ['attributes', 'global', 'calendar_format'], userPreference);
  const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_format'], userPreference);
  const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'time_reg_format'], userPreference);
  const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_positions'], userPreference);

  const [modal, setModal]=useState({title:"Settings", type:"list"});
  const handleClose = ()=>{
    setModal({title:"Settings", type:"list"});
  }


  const getFormatedValue = () => {
    let init = clone(editValues);
    // console.log("init", init)
    for (let key in init) {
        if (key === 'ie_status') {
            init = { ...init, [key]:init[key]?'Active':'' }
        }
    }
    return init;
}

  const handleSubmit = (e) =>{
    e.preventDefault();
    let validate = validateForm(fields, editValues, { calendar_format, date_reg_format, time_reg_format, date_reg_positions });  
    setErrors(validate.errors);
    if (validate.formIsValid) {
      var submitData = {
          data: {
              type: "InboundEmail",
              attributes: getFormatedValue(),
          }
      };
      onSubmit(submitData);
    }
  }

const onSubmit = async (data) => {
    try {
      setLoading(true);

      dispatch(submitInOutboundEmail(data,modal.type)).then(function (res) {
          let id =pathOr('', ['data', 'id'], res);
          if (id!=='') {
              toast(editValues.ie_id==='' || editValues.mail_id===''?"Record created successfully...!":"Record updated successfully...!")
              setModal({title:"Settings", type:"list"});
              setFields({});
              setErrors({});
              setLoading(false);

          } else {
              toast("Something went wrong!");
              setLoading(false);
            }
      });
      
  } catch (e) {
      toast('Something went wrong!');
  }
};

  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>     
      <Dialog fullWidth={true} maxWidth={"lg"} open={props.open} onClose={props.handleClose} aria-labelledby="imap-settings-form">
        <form className={classes.form} onSubmit={handleSubmit} noValidate autoComplete={"off"}>
          <DialogTitle id="customized-dialog-title" onClose={modal.type==='list'?props.handleClose:handleClose}>
            {modal.title}
          </DialogTitle>
          
          <DialogContent>
            <Scrollbars  autoHide={true} style={{height:"60vh"}}>
            {modal.type==='list'?<List modal={modal} setModal={setModal} handleClose={handleClose} setOutboundList={setOutboundList} setFields={setFields} setErrors={setErrors}  />:
            <Inbound type={modal.type} outboundList={outboundList} modal={modal} setModal={setModal}  handleClose={handleClose} 
            editValues={editValues} setEditValues={setEditValues}  fields={fields}    setFields={setFields} setErrors={setErrors} errors={errors}/>}
            </Scrollbars>
          </DialogContent>
          <DialogActions>
            {modal.type!=='list'?<>
            <Button className={classes.btn} type="submit" variant="contained" size="small" color="primary">{loading?<><CircularProgress size={14} style={{ marginLeft: 10, color: "White" }} />{` `}Saving...</>:"Save"}</Button>
            <Button className={classes.btn} variant="contained" size="small" onClick={handleClose} color="primary">Close</Button></>:""}
          </DialogActions>
        </form>
      </Dialog>
    </MuiThemeProvider>
  );
}
